var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.8215,
    cy: 10.6206,
    rx: 10.7046,
    ry: 10.3885,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_3455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4978 6.01001H6.7478L14.2478 15.7147H12.9978L5.4978 6.01001ZM7.7478 6.01001H8.9978L16.4978 15.7147H15.2478L7.7478 6.01001ZM6.4978 6.01001H8.9978V6.98048H6.4978V6.01001ZM12.9978 14.7442H15.4978V15.7147H12.9978V14.7442ZM14.2478 6.01001H15.9978L7.4978 15.7147H5.7478L14.2478 6.01001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_3455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11.6456,
    fill: "white",
    transform: "translate(4.99976 5.03931)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b29684cbfffde62ccce2d71dae80c4a4.svg";
export { ForwardRef as ReactComponent };